import { NAVIGATION_GET_SUCCESS, NAVIGATION_GET_FAILURE } from '../actions/types';
import config from '../configs';

const initialState = {
  config,
  navItems: [],
  isLoading: false,
  isLoaded: false,
};

const nav = (state = initialState, action) => {
  switch (action.type) {
    case NAVIGATION_GET_SUCCESS: {
      return {
        ...state,
        navItems: action.payload.response,
        isLoading: false,
        isLoaded: true,
      };
    }
    case NAVIGATION_GET_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
      };
    }
    default: {
      const { options = {} } = action;

      // Handle setting isLoading to true for raw OCAPI action
      if (options.success === NAVIGATION_GET_SUCCESS) {
        return {
          ...state,
          isLoading: true,
          isLoaded: false,
        };
      }

      return state;
    }
  }
};

export default nav;
